import React, { forwardRef, Ref } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { useStyles } from './AppTextField.styles';
import theme from '../../../styles/theme';
import { BaseTextFieldProps } from '@mui/material/TextField/TextField';

interface IAppTextFieldProps extends BaseTextFieldProps {
  viewMode?: boolean;
  onChange?: (value: any) => void;
  InputProps?: any;
}

const AppTextField = forwardRef(function AppTextField(
  props: IAppTextFieldProps,
  ref?: Ref<HTMLDivElement>,
) {
  const { viewMode = false, variant, ...textFieldProps } = props;
  const { classes } = useStyles(theme);

  if (!viewMode) {
    return (
      <TextField
        ref={ref}
        color="primary"
        classes={{ root: classes.root, ...(props.classes || {}) }}
        {...textFieldProps}
      />
    );
  }

  return (
    <Box className={classes.viewModeWrapper}>
      {props.label && (
        <Typography variant="text-md-sb">{props.label}</Typography>
      )}
      <Typography variant="text-md">{props.value as any}</Typography>
    </Box>
  );
});

export default AppTextField;
